import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { NewActionTaxonomyActionComponent } from '../new-action-taxonomy-action/new-action-taxonomy-action.component';
import { NewActionTaxonomyStrategyComponent } from '../new-action-taxonomy-strategy/new-action-taxonomy-strategy.component';
import { DynamicContentComponent } from 'app/shared/dynamic-content/dynamic-content.component';

declare var gtag;

@Component({
  selector: 'kla-new-action-taxonomy-goals',
  templateUrl: './new-action-taxonomy-goals.component.html',
  styleUrls: ['./new-action-taxonomy-goals.component.scss'],
  standalone: true,
  imports: [ CommonModule, MatExpansionModule, NewActionTaxonomyActionComponent, NewActionTaxonomyStrategyComponent, DynamicContentComponent ]
})
export class NewActionTaxonomyGoalsComponent implements OnInit {


  @Input() goal: any;
  @Input() color: any;
  @Input() isParentOpen: boolean = false;
  @Input()
  public config: any;
  @Input() parentCategoryTitle: any;
  panelOpenState: boolean;

  constructor() { }

  get includeTier() {
    return this.goal.includeTier;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.isParentOpen) {
      if(changes.isParentOpen.previousValue == true && changes.isParentOpen.currentValue == false){
        this.handleClosed();
      }
    }
  }

  ngOnInit(): void {
  }

  handleOpened() {
    this.panelOpenState = true;
    this.trackExpansion();
  }

  handleClosed() {
    this.panelOpenState = false;
  }

  onArrowKeydown(e: KeyboardEvent) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      e.stopPropagation();
      this.panelOpenState = !this.panelOpenState;
    }
  }

  private trackExpansion() {
    if (typeof gtag !== 'undefined') {
      const isStrategyTier = this.includeTier === 'Strategies';
      const childLevel = isStrategyTier ? 'strategy' : 'action';
      const childCount = isStrategyTier
        ? (this.goal.strategies?.length || 0)
        : (this.goal.actions?.length || 0);

      gtag('event', 'action_taxonomy_expanded', {
        'expanded_level': 'goal',
        'new_visible_level': childLevel,
        'expanded_level_title': this.goal.title,
        'child_count': childCount,
        'parent_category_title': this.parentCategoryTitle
      });
    }
  }


}
